import React from "react";
import { Button } from "react-bootstrap";

const PrimaryButton = 
  ({
    onClick = () => {},
    text = "",
    className = "",
    type = "submit",
    onSubmit = () => {},
    disabled = false,
    variant = "primary",
  }) => {
    return (
      <Button
        type={type}
        variant={variant}
        onClick={onClick}
        onSubmit={onSubmit}
        className={className}
        disabled={disabled}
      >
        {text}
      </Button>
    );
  }

export default React.memo(PrimaryButton);
